import customerLove from 'assets/images/campaign-center/opportunity/icons/customer_love.png'
import phoneInviteRewardIcon from 'assets/images/campaign-center/opportunity/icons/phone_invite_reward.png'
import purchaseIcon from 'assets/images/campaign-center/opportunity/icons/purchase.png'
import rewardIcon from 'assets/images/campaign-center/opportunity/icons/reward.png'
import withMerchantMetrics, {
  MetricsProps,
} from 'components/metrics/withMerchantMetrics'
import { buildTranslate } from 'locales'
import React from 'react'
import MetricSection from '../components/MetricSection'
import Header from '../components/Shared/Header'
import HowItWorks from '../components/Shared/HowItWorks'
import Setup from '../components/Shared/Setup'
import Solution from '../components/Shared/Solution'
import SolutionStep from '../components/Shared/SolutionStep'
import UseCase from '../components/Shared/UseCase'

const t = buildTranslate('thanx_campaigns.opportunity.referrals')

export const Referrals: React.FC<MetricsProps> = props => {
  const {
    handleClick,
    isCampaignTypeLoading,
    campaignType,
    merchantMetrics,
    merchantMetricStatuses,
  } = props
  const promoterCount =
    merchantMetrics?.reviewer_count?.data?.promoter_count || 0

  return (
    <div>
      <Header campaignType="referrals" />
      <UseCase campaignType="referrals" />
      <MetricSection
        value={promoterCount}
        description={t('metric')}
        isLoading={merchantMetricStatuses?.reviewer_count?.isLoading}
        className="spearmint-10-bkg"
      />
      <Solution campaignType="referrals">
        <SolutionStep
          icon={phoneInviteRewardIcon}
          iconAlt={t('solution.steps.image_one_alt')}
          text={t('solution.steps.one')}
        />
        <SolutionStep
          icon={rewardIcon}
          iconAlt={t('solution.steps.image_two')}
          text={t('solution.steps.two')}
        />
        <SolutionStep
          icon={purchaseIcon}
          iconAlt={t('solution.steps.image_three_alt')}
          text={t('solution.steps.three')}
        />
        <SolutionStep
          icon={customerLove}
          iconAlt={t('solution.steps.image_four_alt')}
          text={t('solution.steps.four')}
        />
      </Solution>
      <hr className="width-75" />
      <HowItWorks campaignType="referrals" />
      <Setup
        type="referrals"
        isLoading={isCampaignTypeLoading}
        handleClick={handleClick}
        campaignType={campaignType}
      />
    </div>
  )
}

export default withMerchantMetrics(['reviewer_count'])(Referrals)
